const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;

if (!API_BASE_URL) {
  throw new Error("REACT_APP_API_BASE_URL est absente du fichier .env");
}

export const apiConfig = {
  baseURL: API_BASE_URL.replace(/\/+$/, ""),
  storageURL: STORAGE_URL?.replace(/\/+$/, "") ?? "",
  timeout: 15000,
} as const;